import styled from 'styled-components';
import { Colors } from 'core/CssVariables';

export const SDateTimeRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 8px;

  /* Date picker takes the larger share, time controls stay compact. */
  .zest-datetime-date {
    flex: 1 1 auto;
    min-width: 0;
  }
  .zest-datetime-timewrap {
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
    gap: 6px;
  }
  .zest-datetime-time {
    width: 92px;
  }
`;

// Segmented AM / PM switch shown only in 12-hour mode.
export const SPeriodToggle = styled.div`
  display: inline-flex;
  padding: 2px;
  border-radius: 8px;
  background: ${({ theme }) => theme.input.backgroundColor};
  border: 1px solid ${({ theme }) => theme.input.borderColor};
`;

export const SPeriodBtn = styled.button<{ active: boolean }>`
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  padding: 0 9px;
  border-radius: 6px;
  transition: all 0.15s;
  background: ${({ active }) => (active ? Colors.PrimaryColor : 'transparent')};
  color: ${({ active, theme }) =>
    active ? Colors.White : theme.secondaryColor};
`;
